import {
  isToolConsentElicitation,
  type RenderableElicitation,
  type ToolConsentElicitation,
} from '~/components/v2/components/workspace/workspace-agent-panel/schemas/elicitation';

/** `UnknownElicitation.type` is `string`, so equality alone won't narrow the union in JSX. */
export const isToolConsentElicitationEntry = (
  elicitation: RenderableElicitation | null,
): elicitation is ToolConsentElicitation => elicitation !== null && isToolConsentElicitation(elicitation);
